'use client';
import { motion } from 'framer-motion';
import { PropsWithChildren, useState, useEffect } from 'react';

export interface FadeInProps extends PropsWithChildren {
  delay?: number;
  amount?: number | 'some' | 'all';
  once?: boolean;
  yShift?: number;
}

// fade in + slight upward translate when scrolled into view.
export default function FadeInOnScroll({
  children,
  delay = 0,
  amount = 0.2,
  once = true,
  yShift = 48
}: FadeInProps) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <motion.div
      key={isMounted ? 'mounted' : 'unmounted'}
      initial={isMounted ? 'hidden' : 'visible'}
      whileInView="visible"
      viewport={{ amount, once }}
      variants={{
        hidden: { opacity: 0, y: yShift },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 1,
            delay,
            ease: [0.25, 0.1, 0.25, 1]
          }
        }
      }}
    >
      {children}
    </motion.div>
  );
}
